<template>
  <el-dialog
    :append-to-body="true"
    title="访客详细信息"
    :visible.sync="drawerShow"
    direction="ltr"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      style="max-height:780px;overflow: auto"
      label-width="130px"
      class="demo-ruleForm"
    >
      <el-form-item label="访客姓名:" prop="visitorName">
        <el-input
          style="width:90%"
          v-model="ruleForm.visitorName"
          placeholder="请输入访客姓名"
          clearable
          disabled
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="访客手机号码:" prop="visitorMobileNumber">
        <el-input
          style="width:90%"
          v-model="ruleForm.visitorMobileNumber"
          placeholder="请输入访客手机号码"
          clearable
          disabled
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="身份证号码:" prop="identificationNumber">
        <el-input
          style="width:90%"
          v-model="ruleForm.identificationNumber"
          placeholder="请输入身份证号码"
          clearable
          disabled
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="访客单位:" prop="visitorUnit">
        <el-input
          style="width:90%"
          v-model="ruleForm.visitorUnit"
          placeholder="请输入访客单位"
          clearable
          disabled
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="来访时间:" prop="visitingTime">
        <el-date-picker
          v-model="visitingTime"
          type="date"
          placeholder="选择来访时间"
          align="right"
          size="small"
          disabled
          style="width:90%"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="离开时间:" prop="departureTime">
        <el-date-picker
          v-model="departureTime"
          type="date"
          placeholder="选择来访时间"
          align="right"
          size="small"
          disabled
          style="width:90%"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="来访目的:" prop="purposeVisit">
        <el-input
          style="width:90%"
          v-model="ruleForm.purposeVisit"
          placeholder="请输入来访目的"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          clearable
          disabled
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="来访人数:" prop="numberVisitors">
        <el-input
          style="width:90%"
          v-model="ruleForm.numberVisitors"
          placeholder="请输入来访人数"
          clearable
          disabled
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="车牌:" prop="licensePlateRegistration">
        <el-input
          style="width:90%"
          v-model="ruleForm.licensePlateRegistration"
          placeholder="请输入车牌"
          clearable
          disabled
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="访客照片:" prop="visitorPhotos">
        <el-image
          class="image-box"
          :src="$store.state.config.fileUrl + ruleForm.visitorPhotos"
          :preview-src-list="[
            $store.state.config.fileUrl + ruleForm.visitorPhotos
          ]"
        >
        </el-image>
        <!-- <upload-image
          v-model="ruleForm.visitorPhotos"
          :uploadLimit="3"
          style="width:90%"
        ></upload-image> -->
      </el-form-item>
      <el-form-item label="被访人:" prop="intervieweeId">
        <el-select
          v-model="ruleForm.intervieweeId"
          style="width:90%"
          size="small"
          clearable
          placeholder=""
          disabled
        >
          <el-option
            v-for="item in allTeachers"
            :key="item.id"
            :label="item.Name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="demo-drawer__footer insert_data_button_box">
      <div class="col-sm-12 text-center">
        <!-- <el-button
          type="primary"
          size="small"
          @click="saveForm('ruleForm')"
          v-loading="loading"
          >提交</el-button
        > -->
        <el-button @click="handleClose" size="small" v-loading="loading"
          >返回</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import UploadImage from "@/components/UploadImage";
export default {
  name: "VisitorRecordAdd",
  props: {
    checkResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    ruleForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      drawerShow: false,
      visitingTime: "",
      departureTime: "",
      // ruleForm: {
      //   visitorName: '', //访客姓名
      //   visitorMobileNumber: '', //访客手机号码
      //   identificationNumber: '', //身份证号码
      //   visitorUnit: '', //访客单位
      //   visitingStatus: 0, //来访状态
      //   visitingTime: '', //来访时间
      //   departureTime: '', //离开时间
      //   purposeVisit: '', //来访目的
      //   numberVisitors: '', //来访人数
      //   licensePlateRegistration: '', //车牌登记
      //   visitorPhotos: '', //访客照片
      //   schoolId: this.$store.state.schoolId, //所属学校
      //   intervieweeId: '', //被访人id
      // },
      loading: false,
      allTeachers: [] //被访人列表
    };
  },
  components: {
    "upload-image": UploadImage
  },
  mounted() {
    this.getAllTeachers();
  },
  watch: {
    checkResize(newVal) {
      if (newVal) {
        this.visitingTime = this.ruleForm.visitingTime * 1000;
        this.departureTime = this.ruleForm.departureTime * 1000;
        this.drawerShow = true;
      }
    }
  },
  methods: {
    async getAllTeachers() {
      let req = {
        pageSize: 10000,
        pageNum: 1,
        schoolId: parseInt(this.$store.state.schoolId),
        departmentId: "",
        userPhone: "",
        userName: ""
      };
      let res = await this.$Http.getTeacherList(req, true);
      if (res.code == 200) {
        this.allTeachers = res.data.list || [];
      } else if (res.code == 101) {
        this.allTeachers = [];
      } else {
        this.allTeachers = [];
      }
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.ruleForm.visitingTime =
            Number(this.ruleForm.visitingTime) / 1000;
          this.ruleForm.departureTime =
            Number(this.ruleForm.departureTime) / 1000;
          this.addInfo();
        } else {
          return false;
        }
      });
    },
    async addInfo() {
      let req = Object.assign({}, this.ruleForm);
      let res = await this.$Http.addVisitorRecord(req);
      this.loading = false;
      if (res.code == 200) {
        this.handleClose(true);
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "新增失败"
        });
      }
    },
    //   关闭抽屉
    handleClose(type) {
      this.drawerShow = false;
      // this.$emit('handleClose',type)
      // this.$refs.ruleForm.resetFields()
    }
  }
};
</script>
<style scoped lang='scss'>
.image-box{
  width: 100px;
  height: 100px;
}
</style>
